import Service from './Service';

/**
 * 资金管理模块接口
 */
class PayService extends Service {
    /**
     * 预充值生成busiSn
     * @param params
     */
    preRecharge(params) {
        return this.axios.post('api/pay/v1/trade/preRecharge', params);
    }
}

const payService = new PayService();
export default payService;
